import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OpportunitySection } from './components/OpportunitySection';
import { OfferSection } from './components/OfferSection';
export function App() {
  return <main className="w-full min-h-screen bg-slate-900" data-id="element-0">
      <Hero data-id="element-1" />
      <PainSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <OpportunitySection data-id="element-6" />
      <OfferSection data-id="element-7" />
    </main>;
}